<div class="purchase-order-items">
  <div class="flex">
    <div>
      <button class="lum-button" (click)="onBulkInlineEdit()">
        <ng-container *ngIf="!activeBulkEdit; else activeBulkInlineEdit">
          <lum-ui-icon
            icon="edit"
            color="#ffffff"
            width="16"
            height="16"
            class="mr-1"
          ></lum-ui-icon>
          Bulk In-line Edit
        </ng-container>
        <ng-template #activeBulkInlineEdit>
          <lum-ui-icon
            icon="close-circle"
            color="#ffffff"
            width="16"
            height="16"
            class="mr-1"
          ></lum-ui-icon>
          Exit Bulk In-line Edit
        </ng-template>
      </button>
    </div>
    <div class="flex justify-end mb-4 gap-2 grow">
      <button class="lum-button" (click)="onBulkEdit()">
        <lum-ui-icon
          icon="edit"
          color="#ffffff"
          width="16"
          height="16"
          class="mr-1"
        ></lum-ui-icon>
        Bulk Update
      </button>
      <button
        class="lum-button"
        (click)="openBulkCreateLotDialog()"
        *ngIf="
          checkedLineItemCountHasLotTracking > 0 && ftUniqueLotNumberPerSkuEnabled
        "
      >
        <lum-ui-icon
          icon="close-circle"
          color="#ffffff"
          width="16"
          height="16"
          class="mr-1"
        ></lum-ui-icon>
        ({{ checkedLineItemCountHasLotTracking }}) Bulk Create Lot
      </button>
      <button
        class="lum-button"
        (click)="onAddToReceiving()"
        *ngIf="checkedLineItemCount > 0"
      >
        <lum-ui-icon
          icon="close-circle"
          color="#ffffff"
          width="16"
          height="16"
          class="mr-1"
        ></lum-ui-icon>
        ({{ checkedLineItemCount }}) Add to Receiving
      </button>
      <button
        class="lum-button"
        (click)="onSubmit()"
        [disabled]="form.invalid || (loading$ | async)"
        *ngIf="dirtyLineItemCount > 0"
      >
        <ng-container *ngIf="!(loading$ | async); else loader">
          <lum-ui-icon
            icon="close-circle"
            color="#ffffff"
            width="16"
            height="16"
            class="mr-1"
          ></lum-ui-icon>
        </ng-container>
        <ng-template #loader>
          <mat-progress-spinner
            class="progress-spinner mr-1"
            diameter="23"
            mode="indeterminate"
          ></mat-progress-spinner>
        </ng-template>
        {{ '(' + dirtyLineItemCount + ') ' }}
        <ng-container *ngIf="rrLineItemCount <= 0; else bulkReceive">
          Save Changes
        </ng-container>
        <ng-template #bulkReceive> Save Changes and Bulk Receive </ng-template>
      </button>
      <button class="lum-button" (click)="onReset()">
        <lum-ui-icon
          icon="close-circle"
          color="#ffffff"
          width="16"
          height="16"
          class="mr-1"
        ></lum-ui-icon>
        Reset
      </button>
    </div>
  </div>

  <form [formGroup]="form">
    <table class="lum-table lum-table--classic striped">
      <thead>
        <th>
          <mat-checkbox
            class="lum-checkbox"
            [checked]="checkedAllLineItems"
            [indeterminate]="checkedSomeLineItems"
            (change)="onCheckedAllLineItems($event.checked)"
          >
          </mat-checkbox>
        </th>
        <th>Supplier</th>
        <th>PO #</th>
        <th>SKU</th>
        <th>Product Name</th>
        <th *ngxPermissionsOnly="['skuUnitCost.read']" class="text-right"
          >Unit Cost</th
        >
        <th class="text-right">Purchase Qty.</th>
        <th>UOM</th>
        <th class="text-right" *ngIf="ftLotTrackingPageEnabled">Lot</th>
        <th class="text-right">Received Qty.</th>
        <th class="text-right">Add to Receiving</th>
      </thead>
      <tbody formArrayName="lineItems">
        <ng-container
          *ngFor="
            let item of paginatedLineItems;
            trackBy: trackByControlValue;
            let i = index
          "
        >
          <tr
            [formGroupName]="paginationLength + i"
            [class]="
              item.controls.purchasePrice.dirty ||
              item.controls.purchaseQty.dirty ||
              item.controls.addToReceivingQty.dirty
                ? 'bg-yellow-100'
                : ''
            "
          >
            <td>
              <mat-checkbox
                class="lum-checkbox"
                formControlName="checked"
              ></mat-checkbox>
            </td>
            <td>{{ item.value.supplierName }}</td>
            <td>{{ item.value.poId }}</td>
            <td>{{ item.value.sku }}</td>
            <td>{{ item.value.productName }}</td>
            <td
              *ngxPermissionsOnly="['skuUnitCost.read']"
              [class]="
                item.get('purchasePrice')?.dirty &&
                item.get('purchasePrice')?.invalid
                  ? 'bg-red-200'
                  : ''
              "
            >
              <div class="flex justify-content-end gap-4">
                <lum-purchase-order-item-input
                  [control]="item.get('purchasePrice')"
                  [readonly]="!item.value.activePurchasePriceField"
                  [value]="item.value.purchasePrice"
                  [withDecimal]="true"
                  (toggleEvent)="
                    onEditLineItem(
                      purchaseOrderItemField.PURCHASE_PRICE,
                      paginationLength + i
                    )
                  "
                ></lum-purchase-order-item-input>
              </div>
            </td>
            <td
              [class]="
                item.get('purchaseQty')?.dirty && item.get('purchaseQty')?.invalid
                  ? 'bg-red-200'
                  : ''
              "
            >
              <div class="flex justify-content-end gap-4">
                <lum-purchase-order-item-input
                  [control]="item.get('purchaseQty')"
                  [readonly]="!item.value.activePurchaseQtyField"
                  [value]="item.value.purchaseQty"
                  [withDecimal]="true"
                  (toggleEvent)="
                    onEditLineItem(
                      purchaseOrderItemField.PURCHASE_QTY,
                      paginationLength + i
                    )
                  "
                ></lum-purchase-order-item-input>
              </div>
            </td>
            <td>{{ item.value?.uom }}</td>
            <td *ngIf="ftLotTrackingPageEnabled">
              <div
                class="flex justify-content-end gap-4 w-100 text-right"
                *ngIf="item.value?.hasLotTracking"
              >
                <div *ngIf="!item.value.activeLotIdField; else toggleLotDropdown">
                  <span
                    class="text-underline cursor-pointer"
                    (dblclick)="
                      onEditLineItem(
                        purchaseOrderItemField.LOT_ID,
                        paginationLength + i
                      )
                    "
                  >
                    {{ item?.value?.selectedLot?.label || '-- None --' }}
                  </span>
                </div>
                <ng-template #toggleLotDropdown>
                  <lum-rfq-lot-search-dropdown
                    [rfqId]="item.value.rfqId"
                    [selected]="item.value.lot"
                    (selectLotEvent)="onSelectLotNewEvent($event, i)"
                    (createNewLotEvent)="openCreateLotNewDialog(i, item.value)"
                  ></lum-rfq-lot-search-dropdown>
                </ng-template>

                <!-- <lum-purchase-order-item-lot-dropdown
                    [item]="item"
                    [index]="i"
                    [paginationLength]="paginationLength"
                    [purchaseOrderItemField]="purchaseOrderItemField.LOT_ID"
                    [isLotsLoading]="isLotsLoading"
                    [lotsByRfqId]="lotsByRfqId"
                    (editLineItem)="onEditLineItem($event.field, $event.index)"
                    (selectLotEvent)="
                      onSelectLotEvent(
                        $event.event,
                        $event.index,
                        $event.lotId,
                        $event.matSelectComponent
                      )
                    "
                    (openLotListEvent)="
                      onOpenLotListEvent($event.event, $event.index)
                    "
                  >
                  </lum-purchase-order-item-lot-dropdown> -->
              </div>
            </td>
            <td class="text-right">
              {{ item.value.receivedQty | decimalPlaces }}
            </td>
            <td
              [class]="
                item.get('addToReceivingQty')?.dirty &&
                (item.get('addToReceivingQty')?.invalid ||
                  item.value.addToReceivingQty >
                    item.value.purchaseQty - item.value.receivedQty)
                  ? 'bg-red-200'
                  : ''
              "
            >
              <div class="flex justify-content-end gap-4">
                <lum-purchase-order-item-input
                  [withDecimal]="true"
                  [control]="item.get('addToReceivingQty')"
                  [hasComparedValue]="true"
                  [readonly]="!item.value.activeAddToReceivingQtyField"
                  [value]="item.value.addToReceivingQty"
                  [comparedValue]="
                    item.value.purchaseQty - item.value.receivedQty >= 0
                      ? item.value.purchaseQty - item.value.receivedQty
                      : 0
                  "
                  (toggleEvent)="
                    onEditLineItem(
                      purchaseOrderItemField.ADD_TO_RECEIVING_QTY,
                      paginationLength + i
                    )
                  "
                  (inputEvent)="onInput($event, paginationLength + i)"
                ></lum-purchase-order-item-input>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </form>
</div>
<mat-paginator
  [length]="pagination?.total"
  [pageSize]="pagination?.per_page"
  [pageSizeOptions]="paginationConfig.pageSizeOptions"
  [pageIndex]="(pagination?.current_page || 1) - 1"
  (page)="onPaginationEvent($event)"
  aria-label="Select page"
>
</mat-paginator>
